import { useMemo, useState } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { useTranslation } from 'react-i18next';
import {
  initialSettlementBasisMode,
  mapSettlementResult,
  type SettlementBasisMode,
} from '@/utils/approval/openConstructionCostSettlement';
import OpenConstructionCostSettlementReport from './OpenConstructionCostSettlementReport';
export { default as OpenConstructionCostSettlementSnapshot } from './OpenConstructionCostSettlementSnapshot';
import { OpenConstructionCostSettlementRoot } from './styles';

type Props = {
  /** 저장·분석 결과 원문(attributes.data) */
  data: unknown[];
};

/** 234 정산 리포트 — 작성·조회 공용. 판정기준(직접이익 ↔ 영업이익) 전환만 화면 상태로 가짐 */
const OpenConstructionCostSettlementInfo = ({ data }: Props) => {
  const { i18n } = useTranslation();
  // 분석 전에도 레거시처럼 전 항목 "-" 로 틀을 보여줌
  const view = useMemo(
    () => mapSettlementResult(data.length ? data : [{}]),
    [data, i18n.language],
  );
  const [mode, setMode] = useState<SettlementBasisMode | null>(null);
  if (!view) return null;
  const basisMode = mode ?? initialSettlementBasisMode(view);
  return (
    <OpenConstructionCostSettlementRoot className="open-construction-cost">
      <section id="open_construction_cost_settlement_content">
        <OpenConstructionCostSettlementReport
          view={view}
          basisMode={basisMode}
          onToggleBasis={() =>
            setMode(basisMode === 'operating' ? 'direct' : 'operating')
          }
        />
      </section>
    </OpenConstructionCostSettlementRoot>
  );
};

/**
 * attributes.content — 레거시 #open_construction_cost_settlement_content.innerHTML 과 같은 마크업.
 * 레거시 조회 화면이 이 HTML 을 그대로 넣고 자체 CSS·토글로 그림
 */
export const buildOpenConstructionCostSettlementContentHtml = (
  data: unknown[],
): string => {
  const view = mapSettlementResult(data);
  if (!view) return '';
  return renderToStaticMarkup(
    <OpenConstructionCostSettlementReport
      view={view}
      basisMode={initialSettlementBasisMode(view)}
    />,
  );
};

export default OpenConstructionCostSettlementInfo;
